import BalanceRulesRenderer from './BalanceRulesRenderer'
import {CalendarFrequencyType} from 'constants'

class ResetRulesCell extends BalanceRulesRenderer {
    _getRuleValue(data) {
        return data.resetRule ?
               this.formatter(data.resetRule.value) + " " + (data.resetRule.frequency.type === CalendarFrequencyType.ON_HIRE_DATE ?
                                                             CalendarFrequencyType.descriptionFor[data.resetRule.frequency.type] :
                                                             "") + " " + CalendarFrequencyType.parametersFormatterFor[data.resetRule.frequency.type](
                   data.resetRule.frequency.params) :
               "&ndash;";
    }


    _customClassName(data) {
        return "resetRule"
    }
}

export default ResetRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/ResetRulesCell.js